import { enqueueSnackbar } from '../notificationActions';
import { SnackbarMessageVariants } from '../../../helpers/enums';
import { SeasonalityService } from '../../../interfaces/marketInsightsUiServiceInterfaces';
import ApiService from '../../../services/apiService';
import Endpoints from '../../../services/endpoints';

export const SEASONALITY_REQUEST = 'SEASONALITY_REQUEST';
export const SEASONALITY_SUCCESS = 'SEASONALITY_SUCCESS';
export const SEASONALITY_FAILURE = 'SEASONALITY_FAILURE';

const requestSeasonality = (): object => {
    return {
        type: SEASONALITY_REQUEST
    };
};

const receiveSeasonality = (json: object): object => {
    return {
        type: SEASONALITY_SUCCESS,
        payload: json
    };
};

const requestSeasonalityFailed = (): object => {
    return {
        type: SEASONALITY_FAILURE
    };
};

export const fetchSeasonality = (query: any, months: number = 60): Function => {
    return async (dispatch: any): Promise<void> => {
        dispatch(requestSeasonality());

        const requestBody = [{
            ...query,
            months
        }];

        try {
            const json = await ApiService.post(Endpoints.seasonality, requestBody);

            const jsonData: SeasonalityService[] = json.data;
            if (Array.isArray(jsonData) && jsonData.length > 0) {
                // sort the seasonality data by year in descending order
                const sortedData: SeasonalityService[] = jsonData.sort((a: any, b: any): number => {
                    return b.year - a.year;
                });
                dispatch(receiveSeasonality(sortedData));
            } else {
                // If no seasons are returned dispatch an empty array and handle it within the component
                dispatch(requestSeasonalityFailed());
                dispatch(enqueueSnackbar({
                    message: 'Not enough loads to provide specific seasonality data.',
                    variant: SnackbarMessageVariants.Info
                }));
            }
        } catch (err) {
            dispatch(requestSeasonalityFailed());
            dispatch(enqueueSnackbar({
                message: 'Error occurred while fetching seasonality data.',
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};
